import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { RestClient } from '@elderbyte/ngx-starter'
import { Observable } from 'rxjs'
import { environment } from '../../../../../environments/environment'
import { BatchJob, NewBatchSegmentJob } from './batch-job'

@Injectable({
  providedIn: 'root',
})
export class TerminalBatchJobService extends RestClient<BatchJob, string> {
  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/terminal-batch-jobs', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public createNew(cmd: NewBatchSegmentJob): Observable<BatchJob> {
    return this.create(cmd)
  }
}
